<template>
  <v-card>
    <v-card-title>CSV出力の対応 IndexCsvForm.vue </v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="valid">
          <v-row class="mt-4">
            <v-col cols="4">
              <v-radio-group
                label="CSVダウンロードボタン"
                v-model="returnData.enable"
                row
              >
                <v-radio label="無" v-bind:value="false"></v-radio>
                <v-radio label="有" v-bind:value="true"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="3">
              <v-checkbox
                :disabled="methodName != ''"
                v-model="useSubPage"
                label="サブページを含む場合はチェック"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" v-if="useSubPage">
              <v-text-field
                label="サブページを指定しているFromID"
                v-model="subPageFormID"
                :rules="[validation.numonly]"
                hint="チェックを外すと[特殊関数の使用]に切り替え"
                persistent-hint
              ></v-text-field>
            </v-col>
            <v-col cols="3" v-if="!useSubPage">
              <v-text-field
                :disabled="useSubPage"
                label="特殊関数の使用"
                v-model="methodName"
                hint="チェックを入れると[サブページの使用]に切り替え"
                persistent-hint
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="returnData.enable" class="mb-2">
            <v-col cols="12">
              *1
              既知の課題:プラス付きボタンは(,)区切りでデータが保存されるためCSVとバッティングする。(,)→(.)に変更する処理を挟んでいる。<br />
              *2
              入力データに(,)が入る可能性があれば当然(.)に変換されるので注意<br />
              *3 n列目指定に0を入れると出力されない
            </v-col>
            <v-text-field
              label="出力ファイル名"
              outlined
              v-model="returnData.description"
              :rules="[validation.csv]"
              hint="ファイル名に｛｛_date｝｝や｛｛-time｝｝を含むと変換します。dateやtimeの先頭1文字は区切り文字として判断します。二つ以上変換する場合は間に最低1文字必要です。※変数展開として認識されるため全角で記載していますが実際は半角で入力してください。"
              persistent-hint
            ></v-text-field>
          </v-row>
          <div v-for="(v, i) in returnData.value" :key="i" class="mb-4">
            <v-row v-if="returnData.enable">
              <v-col cols="2" class="ma-0">
                <v-text-field
                  class="d-inline"
                  label="n列目"
                  v-model.number="v.csvCol"
                  :rules="[validation.numonly]"
                  required
                  hint="この順番にソートされる"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="ma-0">
                <v-text-field
                  class="d-inline"
                  label="名前"
                  v-model="v.Label"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="ma-0">
                <v-text-field
                  class="d-inline"
                  label="formID"
                  v-model.number="v.ID"
                  :rules="[validation.numonly]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="ma-0">
                <v-select
                  class="d-inline"
                  label="ソート順"
                  v-model="rules[i]"
                  item-text="label"
                  item-value="value"
                  :items="csvConvertRule"
                ></v-select>
              </v-col>
              <v-col cols="1" class="ma-0">
                <v-btn color="primary" @click="del(i)">削除</v-btn>
              </v-col>
              <!-- 追加オプション  -->
              <v-col cols="2" class="ma-0" v-if="rules[i] == 'workTime'">
                <v-text-field
                  class="d-inline"
                  label="基準時間(ミリ秒)"
                  v-model.number="options[i]"
                  :rules="[validation.numonly]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="ma-0" v-if="rules[i] == 'TimeDivision'">
                <v-text-field
                  class="d-inline"
                  label="割合対象のformID"
                  v-model.number="options[i]"
                  :rules="[validation.numonly]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <!--
              <v-row rows="12">
                <v-col cols="auto">
                  <v-radio-group
                    label="表示形式変換"
                    v-model="rules[i]"
                    required
                    row
                  >
                    <v-radio label="無" value="null"></v-radio>
                    <v-radio label="Date→日付のみ" value="dayOnly"></v-radio>
                    <v-radio
                      label="time→時分秒表示"
                      value="convertDay"
                    ></v-radio>
                    <v-radio label="time→工数" value="workTime"></v-radio>
                    <v-radio
                      label="時間を割合分割"
                      value="TimeDivision"
                    ></v-radio>
                    <v-radio label=",含むデータを分割" value="commaDiv"
                      >*分割対象が少ない場合は末尾に全て入る</v-radio
                    >
                  </v-radio-group>
                </v-col>
                <v-col cols="2" class="ma-2" v-if="rules[i] == 'workTime'">
                  <v-text-field
                    class="d-inline"
                    label="基準時間(ミリ秒)"
                    v-model.number="options[i]"
                    :rules="[validation.numonly]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="2" class="ma-2" v-if="rules[i] == 'TimeDivision'">
                  <v-text-field
                    class="d-inline"
                    label="割合対象のformID"
                    v-model.number="options[i]"
                    :rules="[validation.numonly]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-btn color="primary" class="ma-2" @click="del(i)"
                    >削除</v-btn
                  >
                </v-col>
              </v-row>
              -->
          </div>
        </v-form>
        <v-row>
          <v-btn color="success" class="ma-2" @click="reset">初期化</v-btn>
          <v-btn color="success" class="ma-2" @click="add">追加</v-btn>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :color="returnData.color" @click="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { RepositoryFactory } from "../../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  props: {
    value: Array,
    page_id: Number,
    enable: Boolean,
    description: String,
    rule: String,
  },
  data() {
    return {
      returnData: {
        value: this.value,
        rule: [],
        enable: this.enable,
        type: "",
        name: "CSV",
        description: this.description,
      },
      //
      csvConvertRule: [
        { label: "無", value: "null" },
        { label: "Date→日付のみ", value: "dayOnly" },
        { label: "time→時分秒表示", value: "convertDay" },
        { label: "time→コロン(:)表示", value: "convertColon" },
        { label: "time→コロン(:)表示、秒無し", value: "convertColonNoSec" },
        { label: "time→工数", value: "workTime" },
        { label: "時間を割合分割", value: "TimeDivision" },
        { label: "時間を割合分割", value: "TimeDivision" },
        { label: ",含むデータを分割", value: "commaDiv" },
      ],
      //
      values: [], //{ ID: 0, csvCol: 1, Label: },
      rules: [],
      options: [],
      //
      methodName: "",
      useSubPage: false,
      subPageFormID: "0",
      //バリデーション
      valid: true,
      validation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        csv: (value) => {
          return /^.+\.csv$/.test(value) || "ファイル名.csv";
        },
      },
    };
  },
  async mounted() {
    //初期処理
    await this.getInit();
  },
  methods: {
    async getInit() {
      //既存地の処理
      if (this.rule.length > 0) {
        this.rules = this.rule.split(",");
        this.options = Array(this.rules.length);
        this.rules.forEach((r, index) => {
          if (r.indexOf("workTime") != -1) {
            let tmp = r.split(":");
            this.rules[index] = tmp[0];
            this.options[index] = tmp[1];
          } else if (r.indexOf("TimeDivision") != -1) {
            let tmp = r.split(":");
            this.rules[index] = tmp[0];
            this.options[index] = tmp[1];
          }
        });
      }
      //
      let tmp = [];
      if (typeof this.returnData.description != "undefined") {
        tmp = this.returnData.description.split("|");
        this.returnData.description = tmp[0];
      } else {
        this.returnData.description = "";
      }
      if (tmp.length > 1) {
        if (tmp[1] == "useSubPage") {
          this.useSubPage = true;
          this.subPageFormID = tmp[2];
        } else {
          this.methodName = tmp[1];
        }
      }
    },
    async dataInit() {
      this.returnData.enable = true;
      this.returnData.description = "kakanai.csv";
      //
      //検索
      let data = {
        pageID: this.page_id,
        area: [],
      };
      const response = await api.GetForm(data);
      //新規作成
      const nocountType = await api.GetNoCountFormType();
      //変換
      //GetNoCountFormType
      let count = 0;
      this.returnData.value = [];
      for (let j = 0; j < response.data[0].length; j++) {
        for (let i = 0; i < response.data.length; i++) {
          if (!this.match(nocountType, response.data[i][j].Type)) {
            if (
              response.data[i][j].Type != 0 &&
              response.data[i][j].Type != 19
            ) {
              this.returnData.value.push({ ID: 0, csvCol: 1, Label: "" });
              this.returnData.value[count].ID = response.data[i][j].ID;
              this.returnData.value[count].Label = response.data[i][j].Label;
              this.rules[count] = "null";
              count++;
            }
          }
        }
      }
      //
    },
    match(arr, num) {
      let tmp = arr.filter((n) => n == num);
      if (tmp.length == 0) {
        return false;
      }
      return true;
    },
    reset() {
      this.dataInit();
    },
    add() {
      this.returnData.value.push({ csvCol: 0, type: 0 });
      this.rules.push("null");
      this.options.push({ csvCol: 10, type: 0 });
    },
    del(index) {
      if (this.returnData.value.length > 0) {
        this.returnData.value.splice(index, 1);
        this.rules.splice(index, 1);
        this.options.splice(index, 1);
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (!this.returnData.enable) {
          this.returnData.value = null;
          this.$emit("clickSubmit", this.returnData);
          return;
        }
        let tmp = "";
        this.rules.forEach((r, index) => {
          if (r.indexOf("workTime") != -1 || r.indexOf("TimeDivision") != -1) {
            tmp += r + ":" + this.options[index];
          } else {
            tmp += r;
          }
          if (this.rules.length - 1 != index) {
            tmp += ",";
          }
        });
        this.returnData.rule = tmp;
        //特殊関数名の使用
        if (this.methodName != "" && this.methodName != null) {
          if (this.methodName == "useSubPage") {
            alert("特殊関数名にそれはヤメテ!!");
            return;
          }
          this.returnData.description += "|" + this.methodName;
        } else if (this.useSubPage) {
          let str = "|useSubPage|" + String(this.subPageFormID);
          this.returnData.description += str;
        }
        this.$emit("clickSubmit", this.returnData);
      }
    },
  },
};
</script>
